const numberFormats = {
    'pt-br': {
        currency: {
            style: 'currency',
            currency: 'BRL',
        },
        amount: {
            style: 'decimal',
        },
        percent: {
            style: 'percent',
        },
    },
    en: {
        currency: {
            style: 'currency',
            currency: 'USD',
        },
    },
}

export default numberFormats
